import { formatBytes, formatDate, platformFamily, visibilityLabel } from '@ludolio/shared-labs/format';
import type { GamePlatform, LabBuildStatus, LabReleaseStatus, LabTeamRole, LabVisibility } from './types';

export { formatBytes, formatDate, platformFamily, visibilityLabel };

export const PLATFORM_OPTIONS: Array<{ value: GamePlatform; label: string }> = [
  { value: 'windows-x64', label: 'Windows (x64)' },
  { value: 'windows-arm64', label: 'Windows (ARM64)' },
  { value: 'mac-universal', label: 'macOS (Universal)' },
  { value: 'mac-arm64', label: 'macOS (Apple silicon)' },
  { value: 'mac-x64', label: 'macOS (Intel)' },
  { value: 'linux-x64', label: 'Linux (x64)' },
  { value: 'linux-arm64', label: 'Linux (ARM64)' },
];

export const VISIBILITY_OPTIONS: Array<{ value: LabVisibility; label: string; description: string }> = [
  { value: 'private', label: 'Project team', description: 'Only members and reviewers' },
  { value: 'unit', label: 'Unit', description: 'Students and staff in the linked unit' },
  { value: 'organization', label: 'University', description: 'Everyone at your university' },
];

export function platformLabel(platform: GamePlatform): string {
  return PLATFORM_OPTIONS.find((option) => option.value === platform)?.label ?? platform;
}

export const TEAM_ROLE_LABELS: Record<LabTeamRole, string> = {
  owner: 'Owner',
  manager: 'Manager',
  member: 'Member',
};

export const RELEASE_STATUS_LABELS: Record<LabReleaseStatus, string> = {
  draft: 'Draft',
  in_review: 'In review',
  changes_requested: 'Changes requested',
  published: 'Published',
  superseded: 'Replaced',
  withdrawn: 'Taken down',
};

export const BUILD_STATUS_LABELS: Record<LabBuildStatus, string> = {
  uploading: 'Uploading',
  queued: 'Waiting for check',
  scanning: 'Checking',
  passed: 'Passed',
  failed: 'Failed',
  error: 'Check incomplete',
};

